import type { PaperProps } from '@mui/material';
import { Stack } from '@mui/material';
import { Typography } from '@mui/material';
import { Paper } from '@mui/material';
import { isNotNullOrUndefined, isNumber, isString } from '@weft/utils';
import React from 'react';

type SectionContainerProps = Omit<PaperProps, 'title'> & {
  title?: React.ReactNode;
  cta?: React.ReactNode;
};

export const SectionContainer: React.FC<SectionContainerProps> = ({ title, cta, children, ...props }) => {
  return (
    <Paper
      {...props}
      sx={[
        theme => ({
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: '10px',
          textAlign: 'left',
          padding: '24px',
          display: 'flex',
          columnGap: '12px',
          alignItems: 'center',
        }),
      ]}
    >
      <Stack
        rowGap={2}
        width="100%"
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          {isNotNullOrUndefined(title) && getTitle(title)}

          {isNotNullOrUndefined(cta) && cta}
        </Stack>

        {children}
      </Stack>
    </Paper>
  );
};

function getTitle(title: React.ReactNode) {
  if (isString(title) || isNumber(title)) {
    return (
      <Typography
        variant="subtitle1"
        color="text.secondary"
      >
        {title}
      </Typography>
    );
  }

  return title;
}